import { createStyles } from '@material-ui/core';

export default createStyles({
    toolbar: {
        height: '6.0rem',
    },
});
